// test928
(928 && 0);
